const API = process.env.REACT_APP_BACKEND_URL + '/api';

const seen = new Set();
let reported = 0;
const MAX_PER_SESSION = 10;

export function reportClientError(message, stack, source = 'window') {
  try {
    if (!message || reported >= MAX_PER_SESSION) return;
    const key = `${source}:${String(message).slice(0, 120)}`;
    if (seen.has(key)) return;
    seen.add(key);
    reported += 1;
    fetch(`${API}/monitoring/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: String(message).slice(0, 500),
        stack: stack ? String(stack).slice(0, 4000) : null,
        url: window.location.href.slice(0, 500),
        source,
      }),
      credentials: 'include',
      keepalive: true,
    }).catch(() => {});
  } catch { /* the reporter must never throw */ }
}

export function initErrorReporter() {
  if (window.__errorReporterInit) return;
  window.__errorReporterInit = true;
  window.addEventListener('error', (e) => reportClientError(e.message, e.error?.stack, 'window'));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    reportClientError(r?.message || String(r), r?.stack, 'promise');
  });
}
